.tree {
  list-style: none;
  padding: 0;
  margin: 0;
  outline: none;
}

.item {
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  min-height: 28px;
  outline: none;
}

.item:hover {
  background-color: var(--tuna-palette-action-hover);
}

.itemHighlighted {
  background-color: var(--tuna-palette-action-selected);
}

.expandIcon {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.expandIconHidden {
  visibility: hidden;
}

.group {
  list-style: none;
  padding-left: 16px;
  margin: 0;
}
